import type { ProjectLidarUploadStatus } from "./schemas";

export type ProjectStatusGroup = {
  key: string;
  region: string;
  groupName: string | null;
  projectStatuses: ProjectLidarUploadStatus[];
};

export function groupProjectStatuses(
  projectStatuses: ProjectLidarUploadStatus[]
): ProjectStatusGroup[] {
  const groupsByKey = new Map<string, ProjectStatusGroup>();
  for (const projectStatus of projectStatuses) {
    const key = `${projectStatus.region}:${projectStatus.group_id ?? "none"}`;
    const group = groupsByKey.get(key) ?? {
      key,
      region: projectStatus.region,
      groupName: projectStatus.group_name,
      projectStatuses: [],
    };
    group.projectStatuses.push(projectStatus);
    groupsByKey.set(key, group);
  }

  const groups = [...groupsByKey.values()];
  for (const group of groups) {
    group.projectStatuses.sort((first, second) => first.id - second.id);
  }
  return groups.sort((first, second) => {
    if (first.groupName === null) return 1;
    if (second.groupName === null) return -1;
    return (
      first.groupName.localeCompare(second.groupName) ||
      first.region.localeCompare(second.region)
    );
  });
}
